module.exports = __webpack_public_path__ + "static/media/x-twitter.743224b4.svg";